// Mapping van expertise -> auteursrechtvrije foto URL (Pexels, ingetogen tinten)
export const EXPERTISE_IMAGES = {
  "Juridisch": "https://images.pexels.com/photos/5668858/pexels-photo-5668858.jpeg?auto=compress&cs=tinysrgb&w=900",
  "Beleid": "https://images.pexels.com/photos/2310904/pexels-photo-2310904.jpeg?auto=compress&cs=tinysrgb&w=900",
  "HR": "https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg?auto=compress&cs=tinysrgb&w=900",
  "Finance": "https://images.pexels.com/photos/210607/pexels-photo-210607.jpeg?auto=compress&cs=tinysrgb&w=900",
  "ICT": "https://images.pexels.com/photos/270557/pexels-photo-270557.jpeg?auto=compress&cs=tinysrgb&w=900",
  "Projectmanagement": "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=900",
  "Communicatie": "https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg?auto=compress&cs=tinysrgb&w=900",
  "Inkoop/Aanbesteding": "https://images.pexels.com/photos/3760067/pexels-photo-3760067.jpeg?auto=compress&cs=tinysrgb&w=900",
  "Ruimtelijke Ordening": "https://images.pexels.com/photos/417344/pexels-photo-417344.jpeg?auto=compress&cs=tinysrgb&w=900",
  "Sociale Zaken": "https://images.pexels.com/photos/6646917/pexels-photo-6646917.jpeg?auto=compress&cs=tinysrgb&w=900",
  "Anders": "https://images.pexels.com/photos/2526935/pexels-photo-2526935.jpeg?auto=compress&cs=tinysrgb&w=900",
};

export function imageForExpertise(category) {
  return EXPERTISE_IMAGES[category] || EXPERTISE_IMAGES["Anders"];
}

// Formatteert tarief- of salarisrange voor weergave op vacaturekaart
export function formatVacancyComp(v) {
  const nl = (n) => Number(n).toLocaleString("nl-NL");
  // ZZP — uurtarief
  if (v.contract_type === "ZZP" && (v.hourly_rate_min || v.hourly_rate_max)) {
    if (v.hourly_rate_min && v.hourly_rate_max && v.hourly_rate_min !== v.hourly_rate_max)
      return `€ ${v.hourly_rate_min} - € ${v.hourly_rate_max}/u`;
    if (v.hourly_rate_min && !v.hourly_rate_max) return `Vanaf € ${v.hourly_rate_min}/u`;
    if (!v.hourly_rate_min && v.hourly_rate_max) return `Tot € ${v.hourly_rate_max}/u`;
    return `€ ${v.hourly_rate_min || v.hourly_rate_max}/u`;
  }
  // Detacheren/dienstverband — salaris
  if (v.contract_type && v.contract_type !== "ZZP" && (v.salary_min || v.salary_max)) {
    if (v.salary_min && v.salary_max && v.salary_min !== v.salary_max)
      return `€ ${nl(v.salary_min)} - € ${nl(v.salary_max)}/mnd`;
    if (v.salary_min && !v.salary_max) return `Vanaf € ${nl(v.salary_min)}/mnd`;
    if (!v.salary_min && v.salary_max) return `Tot € ${nl(v.salary_max)}/mnd`;
    return `€ ${nl(v.salary_min || v.salary_max)}/mnd`;
  }
  // Beide met range (uurtarief fallback)
  if (v.hourly_rate_min || v.hourly_rate_max) {
    if (v.hourly_rate_min && v.hourly_rate_max && v.hourly_rate_min !== v.hourly_rate_max)
      return `€ ${v.hourly_rate_min} - € ${v.hourly_rate_max}/u`;
    if (v.hourly_rate_min && !v.hourly_rate_max) return `Vanaf € ${v.hourly_rate_min}/u`;
    if (!v.hourly_rate_min && v.hourly_rate_max) return `Tot € ${v.hourly_rate_max}/u`;
    return `€ ${v.hourly_rate_min || v.hourly_rate_max}/u`;
  }
  return null;
}
